import { useData } from '@hooks/useData';
import http from '@core/fetch';
import apiConfig from '@apiConfig';
import { components } from '@apiSchema';
import { iReportProPublication, ReportProPublication } from '@models/ReportProPublication';

const REQUEST_TYPE: keyof typeof apiConfig = 'get publications by tags and packages';
type Response = components['schemas']['ReportProPublicationClient'][];

export const LANDSCAPE_PUBLICATION_TAGS = [139, 267];
export const ON_SITE_PUBLICATION_TAGS = [271];
export const SALES_FOCUS_PUBLICATION_PACKAGES = [44];
const PUBLICATIONS_COUNT = 3;

interface PublicationParams {
    tags?: number[];
    packages?: number[];
}

async function getPublications(
    params: PublicationParams | null,
    count: number,
): Promise<iReportProPublication[]> {
    if (!params) return [];
    const { tags, packages } = params;
    const response = await http.get(REQUEST_TYPE, {
        ...(tags?.length ? { tags } : {}),
        ...(packages?.length ? { packages } : {}),
        count,
    }) as Response;
    return (response || []).map((apiModel) => new ReportProPublication({ apiModel }));
}

export function useLandscapePublications(
    params: PublicationParams | null = { tags: LANDSCAPE_PUBLICATION_TAGS },
) {
    return useData([], getPublications, params, PUBLICATIONS_COUNT);
}
